module.exports = __webpack_public_path__ + "static/media/poker_table_icon.83eba8d5.svg";